import { findStrainBySlug, findProducerBySlug, getCbdDisplay } from '@/lib/strainsData';
import { TERPENES } from '@/lib/terpenesData';
import { translateTerpeneName, translateDescription, translateTerpeneDescription } from '@/lib/dataTranslations';
import { excerpt } from '@/lib/seoTags';
import { shortProducer } from '@/lib/shortProducer';
import { getEffectLanding, getEffectLandingMeta } from '@/lib/effectLandingData';

// Resolve catalog metadata synchronously, without waiting for auth or reviews.
export function getDynamicPageMeta(pathname, language) {
  const pl = language !== 'en';
  const effectMatch = pathname.match(/^\/odmiany-na\/([^/]+)$/);
  if (effectMatch) {
    const topic = getEffectLanding(effectMatch[1]);
    return topic ? getEffectLandingMeta(topic, language) : null;
  }
  const strainMatch = pathname.match(/^\/odmiana\/([^/]+)$/);
  if (strainMatch) {
    const strain = findStrainBySlug(strainMatch[1]);
    if (!strain) return null;
    return {
      title: `${strain.name} (${shortProducer(strain.producer)}${strain.thc != null && strain.thc !== '' ? `, THC ${strain.thc}%` : ''}) – ${pl ? 'profil terpenowy' : 'terpene profile'} | TerpeneAtlas`,
      image: strain.image,
      description: excerpt(translateDescription(strain.id, strain.description, language)) || (pl
        ? `${strain.name} od ${strain.producer}: THC ${strain.thc}%, CBD ${getCbdDisplay(strain)}. Profil terpenowy, opinie pacjentów i dostępność w aptekach. TerpeneAtlas.`
        : `${strain.name} by ${strain.producer}: THC ${strain.thc}%, CBD ${getCbdDisplay(strain)}. Terpene profile, patient reviews and pharmacy availability. TerpeneAtlas.`),
    };
  }
  const terpeneMatch = pathname.match(/^\/terpeny\/([^/]+)(\/odmiany)?$/);
  if (terpeneMatch) {
    const terpene = TERPENES.find(t => t.id === terpeneMatch[1]);
    if (!terpene) return null;
    const name = pl ? terpene.shortName : translateTerpeneName(terpene.shortName, language);
    const list = !!terpeneMatch[2];
    return {
      title: `${name} – ${list ? (pl ? 'odmiany' : 'strains') : (pl ? 'właściwości i działanie' : 'properties and effects')} | TerpeneAtlas`,
      description: (!list && excerpt(pl ? terpene.description : translateTerpeneDescription(terpene.id, language))) || (pl
        ? `${name}: ${list ? 'odmiany medycznej marihuany zawierające ten terpen, ich profile terpenowe i zawartość THC/CBD' : 'aromat, właściwości, temperatura wrzenia, źródła naukowe i odmiany konopi zawierające ten terpen'}. TerpeneAtlas.`
        : `${name}: ${list ? 'medical cannabis strains containing this terpene, their terpene profiles and THC/CBD content' : 'aroma, properties, boiling point, scientific sources and cannabis strains containing this terpene'}. TerpeneAtlas.`),
      image: terpene.image,
    };
  }
  const producerMatch = pathname.match(/^\/producent\/([^/]+)$/);
  const producer = producerMatch && findProducerBySlug(producerMatch[1]);
  return producer ? {
    title: `${producer} – ${pl ? 'odmiany' : 'strains'} | TerpeneAtlas`,
    description: pl
      ? `Odmiany medycznej marihuany od ${producer}: profile terpenowe, THC, CBD i dostępność w polskich aptekach. Poznaj katalog producenta w TerpeneAtlas.`
      : `Medical cannabis strains by ${producer}: terpene profiles, THC, CBD and availability in Polish pharmacies. Explore the producer's catalog on TerpeneAtlas.`,
  } : null;
}